/** Máscaras para CPF e CNPJ. Apenas formatação visual; sem validação de DV. */

export type DocumentType = "cpf" | "cnpj";

const onlyDigits = (v: string) => (v || "").replace(/\D+/g, "");

export function maskCPF(value: string): string {
  const d = onlyDigits(value).slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

export function maskCNPJ(value: string): string {
  const d = onlyDigits(value).slice(0, 14);
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
}

export function maskDocument(value: string, type: DocumentType): string {
  return type === "cpf" ? maskCPF(value) : maskCNPJ(value);
}

/** Retrocompatibilidade: se um valor antigo gravado em `cnpj` tem 11 dígitos, é CPF. */
export function detectDocumentType(value: string | null | undefined): DocumentType {
  const d = onlyDigits(value || "");
  return d.length === 11 ? "cpf" : "cnpj";
}
